import React from 'react';
import { UserRole } from '@grcs/types/UserRole';
import { AdminUserViewPageEnhanced } from '../AdminUser/AdminUserViewPage.enhanced';

export const AdminStudentPageEnhanced: React.FC = () => {
  return <AdminUserViewPageEnhanced user_role={UserRole.STUDENT} />;
};
